export default "__VITE_ASSET__7379f06f__"